import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { searchMovies } from "../../../api/movie-search";
import { FetchedMovie, MovieItem } from "../../../constants/interfaces";
import { useFetch } from "../../../hooks/http-hook";
import { getMovieItem } from "../../../utils/movie";
import SearchResult from "../../Movies/SearchResult";
import Close from "../../SVG/Close";
import LoadingSpinner from "../Spinner/LoadingSpinner";

import SearchIcon from "../Navbar/Icons/SearchIcon";

interface Props {
  onClickResult?: () => void;
}

const SearchInput: React.FC<Props> = (props) => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [searchResult, setSearchResult] = useState<MovieItem[] | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const { sendRequest, isLoading } = useFetch();

  const handleQueryChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const deleteQuery = () => {
    setSearchQuery("");
  };

  const clearResult = () => {
    setSearchResult(null);
    deleteQuery();
    if (props.onClickResult) {
      props.onClickResult();
    }
  };

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (searchQuery.length > 0) {
      timer = setTimeout(() => {
        if (searchQuery === inputRef.current!.value) {
          searchMovies(sendRequest, searchQuery)
            .then((response: any) => {
              const fetchedMovies: FetchedMovie[] = response.results;
              const mappedFetchedMovies = fetchedMovies
                .map((movie) => getMovieItem(movie))
                .filter((movie) => !isNaN(movie.releaseYear));

              setSearchResult(mappedFetchedMovies);
            })
            .catch((error: string) => console.log(error));
        }
      }, 700);
    } else {
      setSearchResult(null);
    }

    return () => clearTimeout(timer);
  }, [searchQuery, sendRequest]);

  return (
    <>
      <div className="relative">
        <SearchIcon className="searchInputIcon" />
        {isLoading && (
          <div className="absolute top-[-1.35rem] -right-6 transform scale-[0.2]">
            <LoadingSpinner />
          </div>
        )}
        <input
          type="text"
          ref={inputRef}
          className="searchInput"
          placeholder="Search movie title..."
          value={searchQuery}
          onChange={handleQueryChange}
        />
        {searchQuery.length > 0 && !isLoading && (
          <Close className="searchInputCloseIcon defaultText" onClick={deleteQuery} />
        )}
        {searchResult && <SearchResult movies={searchResult} onClickMovie={clearResult} query={searchQuery} />}
      </div>
    </>
  );
};

export default SearchInput;
